import PropTypes from "prop-types";
import { useState } from "react";
import { HiXMark } from "react-icons/hi2";
import {
  IoArrowDownCircleOutline,
  IoArrowUpCircleOutline,
} from "react-icons/io5";

const ErrorToast = ({ message, details, onDismiss }) => {
  const [show, setShow] = useState(true);
  const [showDetails, setShowDetails] = useState(false);

  const handleDismiss = () => {
    setShow(false);
    onDismiss();
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-start justify-center pt-4 px-4 pointer-events-none z-50">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
        <div className="p-4">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <svg
                className="h-6 w-6 text-red-500"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <div className="ml-3 w-0 flex-1 pt-0.5">
              <p className="text-sm font-medium text-gray-900">{message}</p>
              {details && (
                <div className="mt-2">
                  <button
                    type="button"
                    className="inline-flex items-center text-sm font-medium text-red-600 hover:text-red-500 focus:outline-none"
                    onClick={() => setShowDetails(!showDetails)}
                  >
                    {showDetails ? (
                      <>
                        Hide details
                        <IoArrowUpCircleOutline className="ml-1 h-4 w-4" />
                      </>
                    ) : (
                      <>
                        Show details
                        <IoArrowDownCircleOutline className="ml-1 h-4 w-4" />
                      </>
                    )}
                  </button>
                  {showDetails && (
                    <div className="mt-2 p-3 bg-gray-50 rounded-md overflow-auto max-h-60">
                      <pre className="text-xs text-gray-700 whitespace-pre-wrap">
                        {typeof details === "string"
                          ? details
                          : JSON.stringify(details, null, 2)}
                      </pre>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="ml-4 flex-shrink-0 flex">
              <button
                className="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                onClick={handleDismiss}
              >
                <span className="sr-only">Close</span>
                <HiXMark className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
        <div className="bg-red-50 px-4 py-3">
          <div className="flex items-center justify-end">
            <button
              type="button"
              className="bg-red-50 text-sm font-medium text-red-700 hover:text-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 rounded-md px-3 py-1.5"
              onClick={handleDismiss}
            >
              Dismiss
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

ErrorToast.propTypes = {
  message: PropTypes.string.isRequired,
  details: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  onDismiss: PropTypes.func.isRequired,
};

export default ErrorToast;
